// Constants
export const afiliacion_registro = () => {
    return {
        afiliacion_registro: {
            id: {
                namepath: ['afiliacion_nueva', 'afiliado_ficha', 'afiliado_crear', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliacion_servicios'],
                type: "number",
                label: "id",
                placeholder: "",
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: true,
                    predeterminate: null,
                }
            },
            id_datos_afiliado: {
                type: "string",
                label: "",
                placeholder: "",
                namepath: ['afiliacion_nueva', 'afiliado_ficha', 'afiliado_crear', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliacion_servicios'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: null,
                    list: "datos_afiliado",
                    label: 'name'
                }
            },
            id_info_afiliacion: {
                type: "string",
                label: "",
                placeholder: "",
                namepath: ['afiliacion_nueva', 'afiliado_ficha', 'afiliado_crear', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliacion_servicios'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: null,
                    list: "",
                    label: 'name'
                }
            },
            id_info_ingresos: {
                type: "string",
                label: "",
                placeholder: "",
                namepath: ['afiliacion_nueva', 'afiliado_ficha', 'afiliado_crear', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliacion_servicios'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: null,
                    list: "",
                    label: 'name'
                }
            },
            id_datos_asesor: {
                type: "string",
                label: "Asesor",
                placeholder: "",
                namepath: ['afiliacion_nueva', 'afiliado_ficha', 'afiliado_crear', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliacion_servicios'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: null,
                    list: "datos_asesor",
                    label: 'name'
                }
            },
            id_datos_razon: {
                type: "string",
                label: "Razón Social",
                placeholder: "",
                namepath: ['afiliacion_nueva', 'afiliado_ficha', 'afiliado_crear', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliacion_servicios'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: null,
                    list: "datos_razon",
                    label: 'name'
                }
            },
            fecha: {
                type: "number",
                label: "Fecha",
                placeholder: "",
                namepath: ['afiliacion_nueva', 'afiliado_ficha', 'afiliado_crear', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliacion_servicios'],
                description: "",
                validate: "",
                datatype: {
                    type: "date",
                    disabled: false,
                    predeterminate: null,
                }
            },
            servicios: {
                type: "string",
                label: "",
                placeholder: "",
                namepath: ['afiliacion_nueva', 'afiliado_ficha', 'afiliado_crear', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliacion_servicios'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: "1",
                    list: "list_servicios",
                    label: 'name'
                }
            },
            valor: {
                type: "number",
                label: "Valor",
                placeholder: "",
                namepath: ['afiliacion_nueva', 'afiliado_ficha', 'afiliado_crear', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliacion_servicios'],
                description: "",
                validate: "required",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: 0,
                    prepend: '$',
                    append: '',
                }
            },
            reporte: {
                type: "number",
                label: "Reporte",
                placeholder: "",
                namepath: ['afiliacion_nueva', 'afiliado_ficha', 'afiliado_crear', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliacion_servicios'],
                description: "",
                validate: "required",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: 0,
                    prepend: '$',
                    append: '',
                }
            },
            comision: {
                type: "number",
                label: "Comision",
                placeholder: "",
                namepath: ['afiliacion_nueva', 'afiliado_ficha', 'afiliado_crear', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliacion_servicios', 'afiliacion_registros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: 0,
                    prepend: '$',
                    append: '',
                }
            },
            nota_delete: {
                type: "text",
                label: "Nota",
                placeholder: "",
                namepath: [''],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null
                }
            },
        }
    }
}